import styled from 'styled-components';

import { CenterFlex, Space } from '@/components/base';
import Button from '@/components/Button/Button';
import Heading from '@/components/Typography/Heading';
import Typo from '@/components/Typography/Typo';
import useColor from '@/hooks/domain/useColor';

const DynamicImportError = () => {
  const color = useColor();
  return (
    <Style d="column">
      <Box d="column">
        <img
          src="/assets/logo-syncly.svg"
          width={128}
          height={128}
          alt="Syncly"
        />
        <Space h={62} />
        <Heading type="h3" color={color.gray700}>
          Update available 🙂
        </Heading>
        <Space h={34} />
        <Typo
          type="body1"
          weight="sb"
          color={color.gray600}
          style={{ textAlign: 'center', maxWidth: 640 }}
        >
          We recommend you to reload your page if you’ve been away for sometime
          so that you can view the latest AI analysis from Syncly!
        </Typo>
        <Space h={68} />
        <Button
          variant="primary"
          sizeType="l"
          style={{ width: 120 }}
          onClick={() => {
            if ('caches' in window) {
              caches.keys().then((names) => {
                names.forEach((name) => {
                  caches.delete(name);
                });
              });
            }
            window.location.reload();
          }}
        >
          Reload
        </Button>
      </Box>
    </Style>
  );
};

const Box = styled(CenterFlex)`
  position: relative;
  z-index: 1;
  padding: 40px;
  border-radius: 16px;
`;

const Style = styled(CenterFlex)`
  position: relative;
  min-height: 100vh;
`;

export default DynamicImportError;
